// Scrolls a list to centre one of its items in the visible area.
//
// The list's own scrollTop, never scrollIntoView: that walks up to every
// scrollable ancestor, and when the widget is embedded the host page owns the
// scroll, so it can move the whole page to reveal a dropdown row.
//
// Measured with rects rather than offsetTop, which is relative to the nearest
// positioned ancestor - not necessarily the list. The browser clamps the
// assignment, so an item near the end lands as close to the top as the
// remaining scroll allows.

// Breathing room above the item, matching the 16px rhythm used elsewhere.
const TOP_GAP = 16

export const centerItemInList = (list, item, gap = TOP_GAP) => {
  if (!list || !item) {
    return
  }

  const listRect = list.getBoundingClientRect()
  const itemRect = item.getBoundingClientRect()

  // An expanded round can be taller than the list; centring it would put its
  // heading out of sight, so those sit at the top instead.
  if (itemRect.height >= listRect.height) {
    list.scrollTop += itemRect.top - listRect.top - gap
    return
  }

  list.scrollTop += (itemRect.top + itemRect.height / 2) - (listRect.top + listRect.height / 2)
}
